import { Pencil, X } from 'lucide-react';

export function AdminUsers({ users, openEditUser, editUser, setEditUser, editName, setEditName, editEmail, setEditEmail, editError, editSuccess, editSaving, saveEditUser }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">User ({users.length})</h2>
      <div className="bg-gray-800 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-700">
            <tr>
              <th className="text-left px-4 py-3">Name</th>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">Telefon</th>
              <th className="text-center px-4 py-3">Erhalten</th>
              <th className="text-center px-4 py-3">Gesendet</th>
              <th className="text-left px-4 py-3">Registriert</th>
              <th className="text-center px-4 py-3">Aktionen</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {users.map((u) => (
              <tr key={u.id} className="hover:bg-gray-700/50">
                <td className="px-4 py-3">{u.name || '-'}</td>
                <td className="px-4 py-3 text-gray-400">{u.email}</td>
                <td className="px-4 py-3 text-gray-400">{u.phone || '-'}</td>
                <td className="px-4 py-3 text-center text-green-400">{u.receivedCount}</td>
                <td className="px-4 py-3 text-center text-blue-400">{u.sentCount}</td>
                <td className="px-4 py-3 text-gray-400">
                  {new Date(u.created_at).toLocaleDateString('de-DE')}
                </td>
                <td className="px-4 py-3 text-center">
                  <button
                    onClick={() => openEditUser(u)}
                    data-testid={`edit-user-${u.id}`}
                    className="inline-flex items-center gap-1 px-2 py-1 text-xs bg-blue-600 hover:bg-blue-700 rounded text-white"
                  >
                    <Pencil size={12} />
                    Bearbeiten
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit User Modal */}
      {editUser && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={() => setEditUser(null)}>
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-md shadow-2xl relative" onClick={e => e.stopPropagation()}>
            <button onClick={() => setEditUser(null)} className="absolute top-3 right-3 text-gray-400 hover:text-white" data-testid="close-edit-modal"><X size={18} /></button>
            <h3 className="text-lg font-semibold mb-4">User bearbeiten</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1">Name</label>
                <input
                  type="text"
                  value={editName}
                  onChange={e => setEditName(e.target.value)}
                  data-testid="edit-user-name"
                  className="w-full rounded-lg bg-gray-700 border border-gray-600 px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-400 mb-1">E-Mail</label>
                <input
                  type="email"
                  value={editEmail}
                  onChange={e => setEditEmail(e.target.value)}
                  data-testid="edit-user-email"
                  className="w-full rounded-lg bg-gray-700 border border-gray-600 px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              {editError && <div className="text-red-400 text-sm">{editError}</div>}
              {editSuccess && <div className="text-green-400 text-sm">{editSuccess}</div>}
              <div className="flex gap-2 justify-end">
                <button onClick={() => setEditUser(null)} className="px-4 py-2 text-sm text-gray-400 hover:text-white">Abbrechen</button>
                <button
                  onClick={saveEditUser}
                  disabled={editSaving}
                  data-testid="save-edit-user"
                  className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 rounded-lg text-white disabled:opacity-50"
                >
                  {editSaving ? 'Speichere...' : 'Speichern'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
